module.exports = __webpack_public_path__ + "static/media/slide2.843caff4.jpg";